import { defineConfig } from '@chakra-ui/react';

const config = defineConfig({
  theme: {
    keyframes: {
      marquee: {
        from: { transform: 'translateX(0)' },
        to: { transform: 'translateX(-50%)' },
      },
      breathe: {
        '0%': { transform: 'scale(1)' },
        '100%': { transform: 'scale(1.12)' },
      },
      heartbeat: {
        '0%, 100%': { transform: 'scale(1)' },
        '15%, 45%': { transform: 'scale(1.25)' },
        '30%': { transform: 'scale(1)' },
      },
    },
  },
});

export default config;
